import React, { useState, useEffect } from 'react';

const KLUBOVI = ['KK Rad', 'KK Rad 2', 'ŽKK Olimp'];
const SEZONE = ['2025/2026', '2026/2027'];
const TAKMICENJA = ['Premijer liga', 'Prva liga RS', 'Kup RS', 'Kup BiH'];

const DEFAULT_TAK = {
  'KK Rad': 'Premijer liga',
  'KK Rad 2': 'Prva liga RS',
  'ŽKK Olimp': 'Premijer liga',
};

const praznaForma = (sezona, klub) => ({
  sezona: sezona || '2025/2026',
  klub: klub || KLUBOVI[0],
  kolo: '',
  datum: '',
  sat: '',
  protivnik: '',
  domaci: true,
  takmicenje: DEFAULT_TAK[klub] || 'Premijer liga',
  slobodnoKolo: false,
});

const prazanGrupniRed = (kolo, takmicenje) => ({
  kolo,
  datum: '',
  sat: '',
  protivnik: '',
  domaci: true,
  takmicenje: takmicenje || 'Premijer liga',
  slobodno: false,
});

const formatDatum = (d) => {
  if (!d) return '—';
  const [g, m, dan] = d.split('-');
  return `${dan}.${m}.${g}`;
};

function Raspored({ raspored, utakmice, dodajRaspored, updateRaspored, obrisiRaspored, setAktivna, globalnaSezona, jeAdmin }) {
  const [filterSezona, setFilterSezona] = useState(globalnaSezona || '2025/2026');
  useEffect(() => { setFilterSezona(globalnaSezona); }, [globalnaSezona]);
  const [filterKlub, setFilterKlub] = useState(KLUBOVI[0]);
  const [prikaz, setPrikaz] = useState('lista');
  const [forma, setForma] = useState(praznaForma(globalnaSezona, KLUBOVI[0]));
  const [editId, setEditId] = useState(null);

  // Grupni unos
  const [grupniKlub, setGrupniKlub] = useState(KLUBOVI[0]);
  const [grupniSezona, setGrupniSezona] = useState(globalnaSezona || '2025/2026');
  const [grupniBrojKola, setGrupniBrojKola] = useState(26);
  const [grupniRedovi, setGrupniRedovi] = useState([]);
  const [grupniGenerated, setGrupniGenerated] = useState(false);
  const [uvozLoading, setUvozLoading] = useState(false);
  const [masovniRedovi, setMasovniRedovi] = useState([]);

  const generateRedove = (brojKola, klub) => {
    const tak = DEFAULT_TAK[klub] || 'Premijer liga';
    setGrupniRedovi(Array.from({ length: parseInt(brojKola) || 1 }, (_, i) => prazanGrupniRed(i + 1, tak)));
    setGrupniGenerated(true);
  };

  const rasporedFilter = raspored
    .filter(r => r.sezona === filterSezona && r.klub === filterKlub)
    .sort((a, b) => (parseInt(a.kolo) || 0) - (parseInt(b.kolo) || 0));

  const jeOdigrana = (r) => {
    if (r.slobodnoKolo) return true;
    return utakmice.some(u =>
      u.klub === r.klub && u.sezona === r.sezona && parseInt(u.kolo) === parseInt(r.kolo)
    );
  };

  const nadjiUtakmicu = (r) => utakmice.find(u =>
    u.klub === r.klub && u.sezona === r.sezona && parseInt(u.kolo) === parseInt(r.kolo)
  );

  const handleSacuvaj = async () => {
    if (!forma.kolo) return alert('Unesi broj kola!');
    if (!forma.slobodnoKolo && !forma.protivnik) return alert('Unesi protivnika!');
    const podaci = forma.slobodnoKolo
      ? { ...forma, protivnik: 'Slobodno kolo', sat: '' }
      : forma;
    if (editId) {
      await updateRaspored(editId, podaci);
      setEditId(null);
    } else {
      await dodajRaspored(podaci);
    }
    setForma(praznaForma(filterSezona, filterKlub));
    setPrikaz('lista');
  };

  const handleEdit = (r) => {
    setForma({
      sezona: r.sezona, klub: r.klub, kolo: r.kolo,
      datum: r.datum || '', sat: r.sat || '', protivnik: r.protivnik,
      domaci: r.domaci, takmicenje: r.takmicenje || DEFAULT_TAK[r.klub] || 'Premijer liga',
      slobodnoKolo: r.slobodnoKolo || false,
    });
    setEditId(r.id);
    setPrikaz('unos');
  };

  const handleGrupniSacuvaj = async () => {
    const validni = grupniRedovi.filter(r => r.slobodno || r.protivnik);
    if (validni.length === 0) return alert('Unesi barem jedan meč ili slobodno kolo!');
    const existingKola = new Set(
      raspored.filter(r => r.sezona === grupniSezona && r.klub === grupniKlub).map(r => parseInt(r.kolo))
    );
    for (const r of validni) {
      if (existingKola.has(parseInt(r.kolo))) continue;
      await dodajRaspored({
        sezona: grupniSezona, klub: grupniKlub,
        kolo: parseInt(r.kolo), datum: r.datum || '',
        sat: r.slobodno ? '' : (r.sat || ''),
        protivnik: r.slobodno ? 'Slobodno kolo' : r.protivnik,
        domaci: r.slobodno ? false : r.domaci,
        takmicenje: r.slobodno ? '' : r.takmicenje,
        slobodnoKolo: r.slobodno || false,
      });
    }
    setFilterKlub(grupniKlub);
    setFilterSezona(grupniSezona);
    setPrikaz('lista');
    setGrupniGenerated(false);
    setGrupniRedovi([]);
  };

  const uvezIzUtakmica = async () => {
    const utakmiceZa = utakmice.filter(u => u.klub === filterKlub && u.sezona === filterSezona);
    if (utakmiceZa.length === 0) return alert('Nema unesenih utakmica za ovaj klub i sezonu!');
    const existingKola = new Set(
      raspored.filter(r => r.klub === filterKlub && r.sezona === filterSezona).map(r => parseInt(r.kolo))
    );
    setUvozLoading(true);
    let dodano = 0;
    for (const u of utakmiceZa) {
      if (existingKola.has(parseInt(u.kolo))) continue;
      await dodajRaspored({
        sezona: u.sezona, klub: u.klub, kolo: parseInt(u.kolo),
        datum: u.datum || '', protivnik: u.protivnik || '',
        domaci: u.domaci !== undefined ? u.domaci : true,
        takmicenje: u.takmicenje || DEFAULT_TAK[u.klub] || 'Premijer liga',
        slobodnoKolo: false,
      });
      dodano++;
    }
    setUvozLoading(false);
    if (dodano === 0) alert('Sve utakmice su već u rasporedu.');
    else alert(`Uvezeno ${dodano} utakmice u raspored.`);
  };

  const updateGrupniRed = (i, polje, vrijednost) =>
    setGrupniRedovi(prev => prev.map((r, idx) => idx === i ? { ...r, [polje]: vrijednost } : r));

  const pokreniUnos = (r) => {
    setAktivna({
      strana: 'utakmice', otvoriUnos: true,
      predUnos: {
        kolo: r.kolo, datum: r.datum || new Date().toISOString().split('T')[0],
        sezona: r.sezona, klub: r.klub, protivnik: r.protivnik,
        domaci: r.domaci, takmicenje: r.takmicenje || DEFAULT_TAK[r.klub] || 'Premijer liga',
      },
    });
  };

  const otvoriMasovniEdit = () => {
    setMasovniRedovi(rasporedFilter.map(r => ({ ...r })));
    setPrikaz('masovni');
  };

  const updateMasovniRed = (id, polje, vrijednost) =>
    setMasovniRedovi(prev => prev.map(r => r.id === id ? { ...r, [polje]: vrijednost } : r));

  const handleMasovniSacuvaj = async () => {
    for (const r of masovniRedovi) {
      const podaci = {
        sezona: r.sezona, klub: r.klub, kolo: r.kolo,
        datum: r.datum || '',
        sat: r.slobodnoKolo ? '' : (r.sat || ''),
        protivnik: r.slobodnoKolo ? 'Slobodno kolo' : (r.protivnik || ''),
        domaci: r.slobodnoKolo ? false : r.domaci,
        takmicenje: r.slobodnoKolo ? '' : (r.takmicenje || DEFAULT_TAK[r.klub] || 'Premijer liga'),
        slobodnoKolo: r.slobodnoKolo || false,
      };
      await updateRaspored(r.id, podaci);
    }
    setPrikaz('lista');
    alert('Raspored sačuvan!');
  };

  const odigrane = rasporedFilter.filter(r => !r.slobodnoKolo && jeOdigrana(r)).length;
  const slobodnaKola = rasporedFilter.filter(r => r.slobodnoKolo).length;
  const preostale = rasporedFilter.filter(r => !r.slobodnoKolo && !jeOdigrana(r)).length;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
        <div className="page-title" style={{ margin: 0 }}>Raspored</div>
        {jeAdmin && prikaz === 'lista' && (
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {rasporedFilter.length > 0 && (
              <button className="btn-edit btn-sm" onClick={otvoriMasovniEdit}>✏️ Uredi raspored</button>
            )}
            <button className="btn-secondary btn-sm" onClick={() => {
              setGrupniKlub(filterKlub);
              setGrupniSezona(filterSezona);
              setGrupniBrojKola(26);
              setGrupniGenerated(false);
              setGrupniRedovi([]);
              setPrikaz('grupni');
            }}>+ Grupni unos</button>
            <button className="btn-primary btn-sm" onClick={() => {
              setForma(praznaForma(filterSezona, filterKlub));
              setEditId(null);
              setPrikaz('unos');
            }}>+ Dodaj meč</button>
          </div>
        )}
        {(prikaz === 'unos' || prikaz === 'grupni' || prikaz === 'masovni') && (
          <button className="btn-secondary btn-sm" onClick={() => { setPrikaz('lista'); setEditId(null); }}>← Nazad</button>
        )}
      </div>

      <div className="filter-bar">
        {SEZONE.map(s => (
          <button key={s} className={'filter-btn ' + (filterSezona === s ? 'active' : '')}
            onClick={() => setFilterSezona(s)}>{s}</button>
        ))}
      </div>
      <div className="filter-bar" style={{ marginBottom: '20px' }}>
        {KLUBOVI.map(k => (
          <button key={k} className={'filter-btn ' + (filterKlub === k ? 'active' : '')}
            onClick={() => setFilterKlub(k)}>{k}</button>
        ))}
      </div>

      {prikaz === 'lista' && rasporedFilter.length > 0 && (
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '20px' }}>
          {[
            { naziv: 'Ukupno kola', vrijednost: rasporedFilter.length },
            { naziv: 'Odigrano', vrijednost: odigrane, boja: '#2ed573' },
            { naziv: 'Slobodna kola', vrijednost: slobodnaKola, boja: '#888899' },
            { naziv: 'Preostalo', vrijednost: preostale, boja: '#ffc107' },
          ].map(s => (
            <div key={s.naziv} className="stat-card">
              <div className="broj" style={s.boja ? { color: s.boja } : {}}>{s.vrijednost}</div>
              <div className="naziv">{s.naziv}</div>
            </div>
          ))}
        </div>
      )}

      {/* Lista rasporeda */}
      {prikaz === 'lista' && (
        <>
          {rasporedFilter.length === 0 ? (
            <div className="card empty-state">
              <div className="icon">📅</div>
              <p>Nema rasporeda za {filterKlub} — {filterSezona}</p>
              {jeAdmin && (
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '12px' }}>
                  <button className="btn-primary" onClick={() => {
                    setGrupniKlub(filterKlub);
                    setGrupniSezona(filterSezona);
                    setGrupniBrojKola(26);
                    setGrupniGenerated(false);
                    setGrupniRedovi([]);
                    setPrikaz('grupni');
                  }}>+ Unesi raspored</button>
                  <button className="btn-secondary" onClick={uvezIzUtakmica} disabled={uvozLoading}>
                    {uvozLoading ? 'Uvoz...' : '↑ Uvezi iz utakmica'}
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              {jeAdmin && (
                <div style={{ marginBottom: '12px' }}>
                  <button className="btn-secondary btn-sm" onClick={uvezIzUtakmica} disabled={uvozLoading}>
                    {uvozLoading ? 'Uvoz...' : '↑ Uvezi iz unesenih utakmica'}
                  </button>
                </div>
              )}
              <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ minWidth: '640px' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'center', width: '60px' }}>Kolo</th>
                        <th style={{ width: '110px' }}>Datum</th>
                        <th style={{ width: '70px', textAlign: 'center' }}>Sat</th>
                        <th>Protivnik</th>
                        <th style={{ textAlign: 'center', width: '90px' }}>D/G</th>
                        <th style={{ width: '120px' }}>Takmičenje</th>
                        <th style={{ textAlign: 'center', width: '90px' }}>Status</th>
                        <th style={{ textAlign: 'center' }}>Akcija</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rasporedFilter.map(r => {
                        const slobodno = r.slobodnoKolo;
                        const odigrana = !slobodno && jeOdigrana(r);
                        const utakmica = !slobodno ? nadjiUtakmicu(r) : null;
                        return (
                          <tr key={r.id} style={{
                            opacity: (odigrana || slobodno) ? 0.65 : 1,
                            background: slobodno ? 'rgba(136,136,136,0.04)' : undefined,
                          }}>
                            <td style={{ textAlign: 'center', fontWeight: '700', color: slobodno ? '#555566' : '#e94560', fontSize: '18px' }}>{r.kolo}</td>
                            <td style={{ color: '#aaa', fontSize: '13px' }}>{formatDatum(r.datum)}</td>
                            <td style={{ textAlign: 'center', color: '#aaa', fontSize: '13px' }}>{r.sat || '—'}</td>
                            <td style={{ fontWeight: slobodno ? '400' : '600', color: slobodno ? '#555566' : '#fff', fontStyle: slobodno ? 'italic' : 'normal' }}>
                              {slobodno ? '— Slobodno kolo —' : r.protivnik}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {!slobodno && (
                                <span style={{ fontSize: '12px', fontWeight: '700', padding: '3px 8px', borderRadius: '4px', background: r.domaci ? 'rgba(46,213,115,0.15)' : 'rgba(83,120,255,0.15)', color: r.domaci ? '#2ed573' : '#5378ff' }}>
                                  {r.domaci ? '🏠 D' : '✈️ G'}
                                </span>
                              )}
                            </td>
                            <td style={{ fontSize: '12px', color: '#888' }}>{!slobodno ? (r.takmicenje || '—') : ''}</td>
                            <td style={{ textAlign: 'center' }}>
                              {slobodno ? (
                                <span style={{ fontSize: '11px', color: '#555566', fontWeight: '600' }}>— Slobodno —</span>
                              ) : odigrana ? (
                                <span style={{ fontSize: '11px', color: '#2ed573', fontWeight: '600' }}>✓ Odigrana</span>
                              ) : (
                                <span style={{ fontSize: '11px', color: '#ffc107' }}>⏳ Čeka</span>
                              )}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                {!slobodno && (odigrana ? (
                                  <button className="btn-secondary btn-sm"
                                    onClick={() => setAktivna({ strana: 'detaljiUtakmice', utakmicaId: utakmica?.id })}>
                                    Pregled
                                  </button>
                                ) : jeAdmin && (
                                  <button className="btn-primary btn-sm" onClick={() => pokreniUnos(r)}
                                    style={{ background: '#2ed573', borderColor: '#2ed573', color: '#000', fontWeight: '700' }}>
                                    ▶ Unesi
                                  </button>
                                ))}
                                {jeAdmin && (
                                  <>
                                    <button className="btn-edit btn-sm" onClick={() => handleEdit(r)}>✏️ Uredi</button>
                                    <button className="btn-danger btn-sm"
                                      onClick={() => { if (window.confirm('Obrisati meč iz rasporeda?')) obrisiRaspored(r.id); }}>✕</button>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </>
      )}

      {/* Pojedinačni unos */}
      {prikaz === 'unos' && (
        <div className="card" style={{ maxWidth: '600px' }}>
          <div className="section-title">{editId ? 'Uredi meč' : 'Dodaj meč u raspored'}</div>
          <div className="form-row">
            <div className="form-group">
              <label>Sezona</label>
              <select value={forma.sezona} onChange={e => setForma({ ...forma, sezona: e.target.value })}>
                {SEZONE.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Klub</label>
              <select value={forma.klub} onChange={e => setForma({ ...forma, klub: e.target.value, takmicenje: DEFAULT_TAK[e.target.value] || 'Premijer liga' })}>
                {KLUBOVI.map(k => <option key={k}>{k}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Kolo</label>
              <input type="number" min="1" value={forma.kolo}
                onChange={e => setForma({ ...forma, kolo: parseInt(e.target.value) || '' })}
                style={{ width: '80px' }} />
            </div>
            <div className="form-group" style={{ justifyContent: 'flex-end', paddingTop: '22px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', color: forma.slobodnoKolo ? '#888899' : '#e0e0f0' }}>
                <input type="checkbox" checked={!!forma.slobodnoKolo}
                  onChange={e => setForma({ ...forma, slobodnoKolo: e.target.checked, protivnik: '' })} />
                Slobodno kolo
              </label>
            </div>
            {!forma.slobodnoKolo && (
              <>
                <div className="form-group">
                  <label>Datum</label>
                  <input type="date" value={forma.datum}
                    onChange={e => setForma({ ...forma, datum: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Sat</label>
                  <input type="text" placeholder="18:30" value={forma.sat || ''}
                    onChange={e => setForma({ ...forma, sat: e.target.value })}
                    style={{ width: '110px' }} />
                </div>
                <div className="form-group">
                  <label>Protivnik</label>
                  <input placeholder="Naziv protivnika" value={forma.protivnik}
                    onChange={e => setForma({ ...forma, protivnik: e.target.value })}
                    style={{ width: '200px' }} />
                </div>
                <div className="form-group">
                  <label>Domaći/Gost</label>
                  <select value={forma.domaci ? 'domaci' : 'gost'}
                    onChange={e => setForma({ ...forma, domaci: e.target.value === 'domaci' })}>
                    <option value="domaci">🏠 Domaći</option>
                    <option value="gost">✈️ Gost</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Takmičenje</label>
                  <select value={forma.takmicenje} onChange={e => setForma({ ...forma, takmicenje: e.target.value })}>
                    {TAKMICENJA.map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
            <button className="btn-primary" onClick={handleSacuvaj}>{editId ? 'Sačuvaj izmjene' : 'Dodaj'}</button>
            <button className="btn-secondary" onClick={() => { setPrikaz('lista'); setEditId(null); }}>Odustani</button>
          </div>
        </div>
      )}

      {/* Masovni edit rasporeda */}
      {prikaz === 'masovni' && (
        <div className="card">
          <div className="section-title">✏️ Uredi raspored — {filterKlub} {filterSezona}</div>
          <p style={{ fontSize: '13px', color: '#666688', marginBottom: '14px' }}>
            Izmijeni podatke direktno u tabeli, pa klikni Sačuvaj sve izmjene.
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ minWidth: '700px' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center', width: '60px' }}>Kolo</th>
                  <th style={{ textAlign: 'center', width: '80px' }}>Slobodno</th>
                  <th style={{ width: '120px' }}>Datum</th>
                  <th style={{ width: '90px' }}>Sat</th>
                  <th>Protivnik</th>
                  <th style={{ textAlign: 'center', width: '100px' }}>D/G</th>
                  <th style={{ width: '140px' }}>Takmičenje</th>
                </tr>
              </thead>
              <tbody>
                {masovniRedovi.map(r => (
                  <tr key={r.id} style={{ background: r.slobodnoKolo ? 'rgba(136,136,136,0.06)' : undefined }}>
                    <td style={{ textAlign: 'center', fontWeight: '700', color: r.slobodnoKolo ? '#555566' : '#e94560', fontSize: '16px' }}>{r.kolo}</td>
                    <td style={{ textAlign: 'center' }}>
                      <input type="checkbox" checked={!!r.slobodnoKolo}
                        onChange={e => updateMasovniRed(r.id, 'slobodnoKolo', e.target.checked)} />
                    </td>
                    <td style={{ padding: '4px' }}>
                      {!r.slobodnoKolo && (
                        <input type="date" value={r.datum || ''}
                          onChange={e => updateMasovniRed(r.id, 'datum', e.target.value)}
                          style={{ width: '116px' }} />
                      )}
                    </td>
                    <td style={{ padding: '4px' }}>
                      {!r.slobodnoKolo && (
                        <input type="text" placeholder="18:30" value={r.sat || ''}
                          onChange={e => updateMasovniRed(r.id, 'sat', e.target.value)}
                          style={{ width: '82px' }} />
                      )}
                    </td>
                    <td style={{ padding: '4px' }}>
                      {r.slobodnoKolo ? (
                        <span style={{ color: '#555566', fontStyle: 'italic', fontSize: '13px' }}>— Slobodno kolo —</span>
                      ) : (
                        <input placeholder="Protivnik" value={r.protivnik || ''}
                          onChange={e => updateMasovniRed(r.id, 'protivnik', e.target.value)}
                          style={{ width: '100%', minWidth: '150px' }} />
                      )}
                    </td>
                    <td style={{ padding: '4px', textAlign: 'center' }}>
                      {!r.slobodnoKolo && (
                        <select value={r.domaci ? 'domaci' : 'gost'}
                          onChange={e => updateMasovniRed(r.id, 'domaci', e.target.value === 'domaci')}
                          style={{ fontSize: '13px' }}>
                          <option value="domaci">🏠 D</option>
                          <option value="gost">✈️ G</option>
                        </select>
                      )}
                    </td>
                    <td style={{ padding: '4px' }}>
                      {!r.slobodnoKolo && (
                        <select value={r.takmicenje || DEFAULT_TAK[r.klub] || 'Premijer liga'}
                          onChange={e => updateMasovniRed(r.id, 'takmicenje', e.target.value)}
                          style={{ fontSize: '13px', width: '130px' }}>
                          {TAKMICENJA.map(t => <option key={t}>{t}</option>)}
                        </select>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
            <button className="btn-primary" onClick={handleMasovniSacuvaj}>💾 Sačuvaj sve izmjene</button>
            <button className="btn-secondary" onClick={() => setPrikaz('lista')}>Odustani</button>
          </div>
        </div>
      )}

      {/* Grupni unos */}
      {prikaz === 'grupni' && (
        <div className="card">
          <div className="section-title">Grupni unos rasporeda</div>

          {/* Konfiguracija */}
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: '20px', padding: '16px', background: '#0d0d1f', borderRadius: '8px', border: '1px solid #2a2a4a' }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Ekipa</label>
              <select value={grupniKlub} onChange={e => { setGrupniKlub(e.target.value); setGrupniGenerated(false); }}
                style={{ fontSize: '14px', fontWeight: '600' }}>
                {KLUBOVI.map(k => <option key={k}>{k}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Sezona</label>
              <select value={grupniSezona} onChange={e => { setGrupniSezona(e.target.value); setGrupniGenerated(false); }}>
                {SEZONE.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Broj kola</label>
              <input type="number" min="1" max="60" value={grupniBrojKola}
                onChange={e => { setGrupniBrojKola(parseInt(e.target.value) || 1); setGrupniGenerated(false); }}
                style={{ width: '80px' }} />
            </div>
            <button className="btn-primary" onClick={() => generateRedove(grupniBrojKola, grupniKlub)}
              style={{ alignSelf: 'flex-end' }}>
              Generiši tabelu
            </button>
          </div>

          {!grupniGenerated && (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666688' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>📋</div>
              <p>Odaberi ekipu i broj kola, pa klikni <strong style={{ color: '#e94560' }}>Generiši tabelu</strong></p>
            </div>
          )}

          {grupniGenerated && (
            <>
              <p style={{ fontSize: '13px', color: '#666688', marginBottom: '12px' }}>
                Unosi za <strong style={{ color: '#fff' }}>{grupniKlub}</strong> — sezona{' '}
                <strong style={{ color: '#e94560' }}>{grupniSezona}</strong>.
                Označi <em>Slobodno</em> za slobodna kola, prazni redovi bez protivnika se ignorišu.
              </p>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ minWidth: '720px' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'center', width: '60px' }}>Kolo</th>
                      <th style={{ textAlign: 'center', width: '90px' }}>Slobodno</th>
                      <th style={{ width: '120px' }}>Datum</th>
                      <th style={{ width: '88px' }}>Sat</th>
                      <th>Protivnik</th>
                      <th style={{ textAlign: 'center', width: '100px' }}>D/G</th>
                      <th style={{ width: '140px' }}>Takmičenje</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grupniRedovi.map((r, i) => (
                      <tr key={i} style={{ background: r.slobodno ? 'rgba(136,136,136,0.06)' : undefined }}>
                        <td style={{ textAlign: 'center', fontWeight: '700', color: r.slobodno ? '#555566' : '#e94560', fontSize: '16px' }}>{r.kolo}</td>
                        <td style={{ textAlign: 'center' }}>
                          <input type="checkbox" checked={r.slobodno || false}
                            onChange={e => updateGrupniRed(i, 'slobodno', e.target.checked)} />
                        </td>
                        <td style={{ padding: '4px' }}>
                          {!r.slobodno && (
                            <input type="date" value={r.datum}
                              onChange={e => updateGrupniRed(i, 'datum', e.target.value)}
                              style={{ width: '116px' }} />
                          )}
                        </td>
                        <td style={{ padding: '4px' }}>
                          {!r.slobodno && (
                            <input type="text" placeholder="18:30" value={r.sat || ''}
                              onChange={e => updateGrupniRed(i, 'sat', e.target.value)}
                              style={{ width: '82px' }} />
                          )}
                        </td>
                        <td style={{ padding: '4px' }}>
                          {r.slobodno ? (
                            <span style={{ color: '#555566', fontStyle: 'italic', fontSize: '13px' }}>— Slobodno kolo —</span>
                          ) : (
                            <input placeholder="Protivnik" value={r.protivnik}
                              onChange={e => updateGrupniRed(i, 'protivnik', e.target.value)}
                              style={{ width: '100%', minWidth: '160px' }} />
                          )}
                        </td>
                        <td style={{ padding: '4px', textAlign: 'center' }}>
                          {!r.slobodno && (
                            <select value={r.domaci ? 'domaci' : 'gost'}
                              onChange={e => updateGrupniRed(i, 'domaci', e.target.value === 'domaci')}
                              style={{ fontSize: '13px' }}>
                              <option value="domaci">🏠 D</option>
                              <option value="gost">✈️ G</option>
                            </select>
                          )}
                        </td>
                        <td style={{ padding: '4px' }}>
                          {!r.slobodno && (
                            <select value={r.takmicenje}
                              onChange={e => updateGrupniRed(i, 'takmicenje', e.target.value)}
                              style={{ fontSize: '13px', width: '130px' }}>
                              {TAKMICENJA.map(t => <option key={t}>{t}</option>)}
                            </select>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ display: 'flex', gap: '12px', marginTop: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
                <button className="btn-primary" onClick={handleGrupniSacuvaj}>
                  Sačuvaj raspored ({grupniRedovi.filter(r => r.slobodno || r.protivnik).length} kola)
                </button>
                <span style={{ fontSize: '12px', color: '#666688' }}>
                  Slobodna: {grupniRedovi.filter(r => r.slobodno).length} · Mečevi: {grupniRedovi.filter(r => !r.slobodno && r.protivnik).length}
                </span>
                <button className="btn-secondary" style={{ marginLeft: 'auto' }} onClick={() => setPrikaz('lista')}>Odustani</button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default Raspored;
